export const ru = {
    'on-condition-mobile': 'по условию «Мобильные устройства»',
    'on-condition-perfomance': 'по условию «Смарт-объявления»',
    'on-condition-video': 'по условию «Объявления с видеодополнениями»'
};
